import opdPrescriptionPdf from '@/services/utils/pdf/opdPrescriptionPdf';
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';

const opdPrescriptionPdfHelper = () => {
    const { exportToPDF } = opdPrescriptionPdf();
    const { fetchBarcode } = handleBarcode();
    const store = useStore();
    const { formatDate } = useDate();
    const userName = store.state.user.user.name;
    var qrcode = '';

    const generatePdf = (company, data, isHideHeader, isHideFooter, customizationPdfFields = {}) => {
        if (isHideFooter) {
            exportToPDF(company, data, qrcode, userName, isHideHeader, isHideFooter, customizationPdfFields);
            return;
        }

        const qrcodeData = JSON.stringify({
            ref_no: data.bill_number ? data.bill_number : '',
            ref_date: data.date ? data.date : formatDate(new Date(), true),
            created_by: userName,
            created_date_time: formatDate(new Date())
        })

        const barCodeQuery = `?code=''&qrcode=${qrcodeData}`;

        fetchBarcode(barCodeQuery).then((res) => {
            qrcode = res.qrcode;
        }).then(() => {
            exportToPDF(company, data, qrcode, userName, isHideHeader, isHideFooter, customizationPdfFields);
        }).catch((e) => {
            exportToPDF(company, data, qrcode, userName, isHideHeader, isHideFooter, customizationPdfFields);
        })
    }

    return {
        generatePdf
    }
}

export default opdPrescriptionPdfHelper;
